module.exports = __webpack_public_path__ + "img/b-pink-s.e7f8f80a.png";